import EventEmitter from "../event-emitter";

export default class ButtonsInput {
    constructor(props = {}) {
        this.props = props;

        this.$root = props.$root;
        this.$buttons = this.$root.querySelectorAll('button');

        this._eventEmitter = new EventEmitter(this.props.subscriptions || []);
        this.value = null;

        this.VALUE_CHANGE_EVENT = 'valueChange';

        this.init();
    }

    init() {
        this._checkProps();
        this._addSubscriptions();
    }

    _checkProps() {
        if (!this.$buttons.length) {
            throw new Error('ButtonsInput: Buttons missing');
        }
    }

    _addSubscriptions() {
        this.$buttons.forEach(($button) => {
            $button.addEventListener('click', () => {
                this.unselectAll();
                this.value = $button.dataset.value;
                $button.classList.add('-active');
                this._eventEmitter.dispatch(this.VALUE_CHANGE_EVENT, this.value);
            });
        });
    }

    unselectAll() {
        this.$buttons.forEach(($button) => {
            $button.classList.remove('-active');
        });
    }

    setInitialState() {
        this.unselectAll();
        this.value = null;
        this._eventEmitter.dispatch(this.VALUE_CHANGE_EVENT, this.value);
    }
}